import { RulesService } from 'app/pages/rules/rules.service';
import { Injector } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Tr2ValidationBuilder } from 'app/utils/trip2-query-builder/tr2-validation-builder';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';

export class ParentModule {

  private _service;
  private _toastrAlertHelper;
  protected _loading;
  protected actions = new Subject<any>();
  protected onApplyingRules: boolean; //Variable que dice si las reglas se estan cargando o plicando

  // actions$ = this.actions.asObservable();
    protected $actions = new Subject<any>();

  actionNames = [];

  protected multiActions = new Subject<any>();
  multiActions$ = this.multiActions.asObservable();

  // TODO New implementation of action load on an observable
  private actionsList = new BehaviorSubject<string[]>([]);
  actionsList$ = this.actionsList.asObservable();

  constructor ( protected selector , private injector: Injector) {
    this._service = this.injector.get(RulesService);
    this._toastrAlertHelper = this.injector.get(ToastrAlertHelper);
    this._loading = this.injector.get(T2LoadingService);
    this.getActions();
  }

  /**
   * @description
   */
  getActions(customSelector?): Observable<any> {
    this._loading.show();
    this.onApplyingRules = true;
    return this._service
    .getRulerByCode(customSelector ? customSelector : this.selector)
    .finally(() => {
      this._loading.hiden();
      this.onApplyingRules = false;
    })
    .subscribe(
      success => {
        this.structure(success);
        if (success.actions) {
          this.actionNames = success.actions.map((el) => {
            return el.actionname;
          });
          this.$actions.next(this.actionNames);
          // TODO New implementation of action load on an observable
          this.actionsList.next(this.actionNames);

        }
        return success;
      },
      error => {
        this._toastrAlertHelper.error(error.message);
      }
    );
  }

    /**
   * @description
   */
  getActionsForPayor(payor): Observable<any> {
    // this._loading.show();
    this.onApplyingRules = true;
    return this._service
    .getRulerByCodeAndPayor(this.selector, payor)
    .finally(() => {
      this.onApplyingRules = false;
      this._loading.hiden();
    })
    .subscribe(
      success => {
        this.structure(success);
        return success;
      },
      error => {
        this.actions.next({
          description: '',
          icon: 'data.icon',
          moduleid: 0,
          actionsArray: [],
          actions: {}
        });
        this._toastrAlertHelper.error(error.message);
      }
    );
  }

  /**
   * @description
   */
  getActionsForPayors(payors: any): Observable<any> {
    this.onApplyingRules = true;
    return this._service
    .getRulerByCodeAndPayors(this.selector, payors)
    .finally(() => {
      this.onApplyingRules = false;
    })
    .subscribe(
      success => {
        const allRules = [];
        success.forEach((rule: any) => {
          allRules.push(this.structureNotEmit(rule));
        });
        this.multiActions.next(allRules);
        return success;
      },
      error => {
        this.multiActions.next([]);
      }
    );
  }

  structureNotEmit (data: any) {
    try {
      const result = {
        description: data.description,
        icon: data.icon,
        payorid: data.payorid,
        moduleid: data.moduleid,
        actionsArray: [],
        actions: {}
      };
      const obj = {};
      data.actions.forEach(element => {
        if (element.rule) {
          element.rule = JSON.parse(element.rule);
        } else {
          element.rule = [];
        }
        obj[element.actionname] = element;
      });
      result.actions = obj;
      result.actionsArray = data.actions;
      return result;
    } catch (error) {
      return {
          description: '',
          icon: 'data.icon',
          payorid: undefined,
          moduleid: 0,
          actionsArray: [],
          actions: {}
      };
    }

  }

  structure (data) {
    try {
      const result = {
        description: data.description,
        icon: data.icon,
        moduleid: data.moduleid,
        actionsArray: [],
        actions: {}
      };
      const obj = {};
      data.actions.forEach(element => {
        if (element.rule) {
          element.rule = JSON.parse(element.rule);
        } else {
          element.rule = [];
        }
        obj[element.actionname] = element;
      });
      result.actions = obj;
      result.actionsArray = data.actions;
      this.actions.next(result);
    } catch (error) {
      this._toastrAlertHelper.error('An error has been generated when building the rules for the "app-marketing" module', 'Rules');
      this.actions.next({
          description: '',
          icon: 'data.icon',
          moduleid: 0,
          actionsArray: [],
          actions: {}
      });
    }

  }

  /**
   * this return true if action is allowed
   */
  isAllowedAction(actionName) {
    return this.actionNames.includes(actionName);
  }

  applyRules(form: FormGroup, action: string, additionalRules?: any[], defaultHidden?: string[]) {
    this._loading.show();
    this.onApplyingRules = true;
    // Each call shows the loading once, so it must hide it once. The subscription stays alive
    // and runs on every later emission, which would close other active loadings.
    let loadingHidden = false;
    this.actions
    .finally(() => {
      this.onApplyingRules = false;
    })
    .subscribe((rules) => {
      if (action in rules.actions) {
        rules.actions[action].rule = Array.isArray(rules.actions[action].rule)
          ? rules.actions[action].rule
          : [];

        if (Array.isArray(additionalRules) && additionalRules.length) {
          rules.actions[action].rule = [
            ...rules.actions[action].rule,
            ...additionalRules
          ];
        }

        Tr2ValidationBuilder.init(form, rules.actions[action].rule, defaultHidden);
      } else {
        form.disable();
      }
      if (!loadingHidden) {
        loadingHidden = true;
        this._loading.hiden();
      }
    });
  }

  onLoadingRules() {
    return this.onApplyingRules;
  }

}





// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/ParentClass/parent-module.ts